export const userKeys = {
  all: ['users'] as const,
  current: () => [...userKeys.all, 'current'] as const,
  visitedCountries: (userId: number) => [...userKeys.all, userId, 'visitedCountries'] as const,
} as const;
